import { Link } from 'gatsby';
import * as React from 'react';
export default {
  Link,
  React
};